import * as React from 'react';
import { Route } from "react-router";

import { Modal } from "../../../../components/Modal/Modal";
import { TwoButtonDialog } from "../../Dialogs/TwoButtonDialog";

export interface EditCreateEntityProps
{
    path: string;
    renderEdit?: () => JSX.Element;
    
    title: string;
    okTitle: string;
    cancelTitle?: string;
    ok: () => void;
    cancel: () => void;
}

export const EditCreateEntityRoute = (props: EditCreateEntityProps) =>
{
    const { path, renderEdit, ...dialogProps } = props;
    return (
        <Route path={path} render={() => (
            <Modal>
                <TwoButtonDialog {...dialogProps}>
                    {renderEdit()}
                </TwoButtonDialog>
            </Modal>)
        } />
    );
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/EditCreate/EditCreateEntityRoute.tsx